import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";

import api, { api_without_cancellation } from "../../api/api";
import { getClientId } from "../../Utils/helper";
import avatar from "../../../public/bp_assets/img/avatar_new.svg";

function SendEmailPopUp({
  emailPopUp,
  handleCloseEmailPopUp,
  attachPdfToCaseFile,
  container,
  docName,
  isFromLetterPopup = false,
  onEmailSent = null,
  saveDraft = null,
}) {
  const [clientData, setClientData] = useState({});
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [userData, setUserData] = useState({});

  const origin = process.env.REACT_APP_BACKEND_URL;
  const [loading, setLoading] = useState(false);

  const [copyCheck, setCopyCheck] = useState(true);
  const [subject, setSubject] = useState("Please see the attached document");
  const [emailText, setEmailText] = useState("");

  const updatePdfDoc = async () => {
    if (!container.current) {
      console.error("Editor not ready");
      return;
    }

    const content = await container.current.save();

    if (!content || content.byteLength === 0) {
      console.error("Error: Document content is empty.");
      return;
    }

    const renamedFile = new File([content], `${docName || "document"}.docx`, {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });

    const formData = new FormData();
    formData.append("file", renamedFile);
    try {
      const response = await api.post(`${origin}/api/documents/word-to-pdf/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      const { data } = response.data;
      const pdfBlob = new Blob([Uint8Array.from(atob(data), (c) => c.charCodeAt(0))], {
        type: "application/pdf",
      });
      return pdfBlob;
    } catch (error) {
      console.error("Error printing document:", error);
      return renamedFile;
    }
  };

  const sendEmail = async () => {
    setLoading(true);

    // First save the draft to get the proper doc_id from DocumentDrafts
    let savedDocId = null;
    if (isFromLetterPopup && saveDraft) {
      try {
        savedDocId = await saveDraft();
        if (!savedDocId) {
          console.error("Failed to save draft before sending email");
          setLoading(false);
          return;
        }
      } catch (error) {
        console.error("Error saving draft before email:", error);
        setLoading(false);
        return;
      }
    }

    const content = await updatePdfDoc();
    const renamedFile = new File([content], `${docName}.pdf`, {
      type: content.type,
    });

    if (copyCheck) {
      await attachPdfToCaseFile();
    }
    const url = `${origin}/api/client-page/send-email-to-client/${getClientId()}/`;

    const formData = new FormData();
    formData.append("to", clientData?.primary_email?.email);
    formData.append("subject", subject);
    formData.append("body", emailText);
    formData.append("reply", true);
    formData.append("file", renamedFile);

    try {
      await api_without_cancellation.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      handleCloseEmailPopUp();

      // If from letter popup, notify parent with the SAVED doc_id and close
      if (isFromLetterPopup && onEmailSent && savedDocId) {
        onEmailSent(savedDocId);
      }
    } catch (error) {
      console.error("Error making POST request:", error);
      setLoading(false);
    }
  };

  const fetchClientPage = async () => {
    try {
      const response = await api_without_cancellation.get(
        `${origin}/api/get-client-by-id/?client_id=${getClientId()}`
      );

      if (response.status === 200) {
        const client_data = response.data.client;
        const user_data = response.data.user;
        setClientData(client_data);
        setUserData(user_data);
        setEmailText(`Dear ${client_data?.first_name} ${client_data?.last_name},

Please see the attached document.

Thank you,
${user_data?.first_name} ${user_data?.last_name}`);
      }
    } catch (error) {
      console.error("Failed to fetch client data:", error);
    }
  };

  useEffect(() => {
    fetchClientPage();
  }, []);

  return (
    <>
      <Modal
        show={emailPopUp}
        onHide={handleCloseEmailPopUp}
        centered
        dialogClassName="modal-dialog modal-dialog-centered"
      >
        <Modal.Header className="tfbp-modal-header">
          <h5 className="tfbp-modal-title">
            SEND EMAIL TO{" "}
            {clientData?.profile_pic ? (
              <div className="ic ic-19 m-l-5 m-r-5 m-t-5 m-b-5">
                <img
                  className={"rounded-circle h-100 object-fit-cover theme-ring"}
                  src={clientData?.profile_pic}
                  alt="Profile"
                />
              </div>
            ) : (
              <div className="ic ic-19 m-l-5 m-r-5 m-t-5 m-b-5">
                <img className={"rounded-circle h-100 object-fit-cover "} src={avatar} />
              </div>
            )}
            {clientData?.first_name} {clientData?.last_name}
          </h5>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Email Subject Greeting:</Form.Label>
              <Form.Control
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
              <Form.Label>Type Email:</Form.Label>
              <Form.Control
                as="textarea"
                style={{ height: "150px" }}
                value={emailText}
                onChange={(e) => setEmailText(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
              <div className="d-flex align-items-center">
                <input
                  type="checkbox"
                  id="copyCheck"
                  className="form-check mb-0"
                  checked={copyCheck}
                  onChange={(e) => setCopyCheck(e.target.checked)}
                />
                <label className="form-check-label mb-0 m-l-5" htmlFor="copyCheck">
                  Save PDF copy of document to Client&apos;s Case File
                </label>
              </div>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer
          style={{
            padding: "5px",
          }}
          className="m-0 padding-outside-btn-new-provide "
        >
          <Button
            variant="secondary"
            className="height-25 d-flex align-items-center justify-content-center"
            onClick={handleCloseEmailPopUp}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className="height-25 d-flex align-items-center justify-content-center"
            onClick={sendEmail}
          >
            {loading ? "Sending.." : "Send"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SendEmailPopUp;
